import styled from 'styled-components';

export const ContainerWindowTitle = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 50px;
  .directTituloJanela {
    min-width: 100%;
    margin-left: unset !important;
    /* z-index: -1; */
  }
  .saib-button-titulo-janela {
    position: relative;
    top: 3.3px;
  }
  .h5Titulo {
    position: relative;
    top: -3px;
  }
  @media (max-width: 768px) {
    margin-top: 0px;
    margin-left: 0px;
    .directTituloJanela {
      margin-top: 50px;
      min-width: 100%;
      margin-left: unset !important;
    }
  }
`;

export const Container = styled.div`
  padding: 0px 10px 0px 10px;
  background-color: #fff;
  height: 100vh;
  margin-left: 64px;
  @media only screen and (max-width: 768px) {
    margin-left: 0px;
  }
`;

export const Linha = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: nowrap;
  width: 100%;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 5px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
  div {
    padding-right: 10px;
  }
  input[type='checkbox'] {
    opacity: inherit !important;
    position: inherit !important;
    pointer-events: inherit !important;
  }
`;

export const DivDetalhe = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (max-width: 768px) {
    padding-top: 10px;
  }
`;

export const LinhaRodape = styled.div`
  padding-bottom: 20px;
  padding-top: 20px;
  padding-right: 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px 0px 0px 0px;
  margin: 10px 10px 0px 10px;
  background-color: white;
`;

export const DivRodape = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  button {
    align-items: center;
    display: flex !important;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    button {
      margin-left: 6px !important;
      margin-top: 8px !important;
      margin-bottom: 10px !important;
      justify-content: center;
      width: 100% !important;
    }
  }
`;

export const LinhaKanban = styled.div`
  width: 100%;
  background-color: white;
  display: flex;
  overflow-x: auto;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 10px;
`;

export const Kanban = styled.div`
  color: #555555;
  height: auto;
  min-width: 300px;
  max-width: 300px;
  margin-right: 15px;
  border: ${(props) =>
    props.cor !== undefined
      ? '1px solid ' + props.cor + '99'
      : '1px solid #ccc'};
  border-radius: 10px;
  padding: 0px 10px 0px 10px;
`;
export const KanbanContainer = styled.div`
  color: #555555;
  height: auto;
  width: 100%;
  overflow-y: auto;
  padding-top: 5px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 5px;
`;

export const DivBaseKanban = styled.div`
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0px 0px 4px 2px #cccccca1;
  margin-bottom: 10px;
  width: 95%;
`;

export const DivBaseKanbanTituloPai = styled.div`
  background-color: ${(props) =>
    props.cor !== undefined ? props.cor : 'white'};
  color: white;
  padding-left: 5px;
  margin-top: 5px;
  border-radius: 4px;
`;

export const DivBaseKanbanTitulo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 5px;
  padding-right: 5px;
  span {
    margin-bottom: 20px;
    padding: 2px 4px 0px 4px;
    flex: 3;
  }
  button.btn.saib-button.is-cancel {
    width: 25px !important;
    background-color: white !important;
    margin-top: 0px !important;
  }
`;

export const DivBaseKanbanBase = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 5px;
  button.botao-base {
    width: auto !important;
    margin-top: 0px !important;
    background-color: #61098a !important;
    color: white !important;
  }
`;

export const DivBaseKanbanCorpo = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 10px 2px 2px 10px;
  margin: 5px;
  border-radius: 4px;
`;
export const DivBaseKanbanLinha1 = styled.div`
  display: flex;
  padding: 0px 0px 0px 10px;
  font-size: small;
  justify-content: space-around;
  span {
    display: flex;
    padding: 5px;
  }
`;
